import { render, staticRenderFns } from "./SaneamentoVocChooseParamentrosComCa.vue?vue&type=template&id=1b2a94df&"
import script from "./SaneamentoVocChooseParamentrosComCa.vue?vue&type=script&lang=js&"
export * from "./SaneamentoVocChooseParamentrosComCa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VFileInput,VRow,VSelect,VTextField})
